/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import { Stars } from '../images';

declare let onetext : OneText;

export const BrandBackgroundBlackFriday = () : JSX.Element => (
    <div className={ 'absolute inset-0' }>

        <img
            className={ 'absolute rotate-90 xl:rotate-0 -bottom-28 xl:top-64 -left-10 w-[380px]' }
            src={ Stars } />
        <img
            className={ 'hidden md:block absolute top-0 xl:top-64 -right-10 w-[380px] -scale-x-100' }
            src={ Stars } />
    </div>
);
